module.exports = __webpack_public_path__ + "media/images/google-2556016b5a555d607b49871e15b90bd2.svg";